import React from "react";
import Content from "../components/elements/Content";
import PageWrapper from "../components/elements/PageWrapper";
import { Link } from "react-router-dom";

const CallForWorkshops = () => {
    return (
        <PageWrapper>
            <Content>
                <h1>Call for Workshop Proposals</h1>
                <hr />
                <p>
                    16th IEEE/ACM International Conference on Utility and Cloud Computing (<strong>UCC 2023</strong>)
                    <br />
                    <Link to="https://ucc-conference.org">www.ucc-conference.org</Link>
                </p>
                <p>
                    Taormina (Messina), Italy
                    <br />
                    <strong>4-7 Dec. 2023</strong>
                </p>
                <p>
                    Workshop inquiries should be sent by e-mail to the workshops chairs (Luiz Bittencourt, Valeria Cardellini)
                </p>
                <h2>CONTEXT & SCOPE</h2>
                <p>
                The IEEE/ACM International Conference on Utility and Cloud Computing is a premier IEEE/ACM conference covering all areas related to utility computing and cloud and edge computing services.
                </p>
                <p>
                This will be the 16th UCC in a successful conference series of community-driven events. Previous events were held in Shanghai, China (Cloud 2009), Melbourne, Australia (Cloud 2010 & UCC 2011), Chennai, India (UCC 2010), Chicago, USA (UCC 2012), Dresden, Germany (UCC 2013), London, UK (UCC 2014), Limassol, Cyprus (UCC 2015), Shanghai, China (UCC 2016), Austin, Texas, USA (UCC 2017), Zurich, Switzerland (UCC 2018), and Auckland, New Zealand (UCC 2019), Online (UCC 2020), Leicester, UK/hybrid online (UCC 2021),  Vancouver, WA, USA (UCC 2022).
                </p>
                <p>Proposals for workshops should be submitted in PDF format, must not exceed 2 pages in length and contain the following information.</p>
                <ol>
                    <li>Title and brief technical description of the workshop, specifying the goals and the technical issues that will be the focus of the workshop.</li>
                    <li>A brief description of why and to whom the workshop is of interest. </li>
                    <li>A list of related workshops or similar events held in the last 3 years, or to be held in 2023.</li>
                    <li>
                        The names and contact information (web page, email address) of the proposed technical program committee. This international committee should consist of at least 10 people knowledgeable about the technical issues to be
                        addressed and preferably not more than two members of the same institution. Ideally, there should also be two organizers from distinct institutions and countries.
                    </li>
                    <li>
                        A description of the qualifications of the organizers (who would be the Workshop Chairs) with respect to organizing this workshop. This can include papers published in the proposed topic area, previous workshop organization,
                        and other relevant information.
                    </li>
                </ol>
                <p>
                    Submit your workshop by using the following link:<br/><Link to="https://cmt3.research.microsoft.com/UCCBDCAT2023">https://cmt3.research.microsoft.com/UCCBDCAT2023</Link>
                </p>
                <br />
                <h2>IMPORTANT DATES</h2>
                <p>
                    <del><strong>Workshop Proposals Due</strong>: 14 June 2023</del>
                    <br />
                    <del><strong>Notification of Acceptance</strong>: 15 June 2023</del>
                    <br />
                    <strong>URL of Workshop</strong>: 7 July 2023
                    <br />
                    <strong>Camera-ready & Registration</strong>: 21 October, 2023
                    <br />
                    <strong>Workshops</strong>: December 2023
                </p>
                <p>Note: Workshops may be approved and announced early based on quality of the proposal.</p>
                <br />
                <h2>TOPICS OF INTEREST</h2>
                <p>
                    We encourage workshops on both established research topics to promote newly developed ideas as well as workshops on emerging topics with sufficient body of research being carried out. Topics of interest include but are not limited
                    to:
                </p>
                <ul>
                    <li>Applications: Games, Social Networks, Scientific Computing (e-science) and Business</li>
                    <li>Architectural and Programming models for Cloud-Edge Continuum</li>
                    <li>Artificial Intelligence in the Cloud-Edge Continuum</li>
                    <li>Artificial Intelligence as a Service (AIaaS)</li>
                    <li>Cloud-Edge Continuum Business and Legal Implications Beyond Technology</li>
                    <li>Cloud-Edge Continuum Management: Autonomic, Adaptive, Self-*, SLAs, Performance Models and Monitoring</li>
                    <li>Cloud-Edge Continuum Middleware, Stacks, Tools, Delivery Networks and Services at All Layers (XaaS)</li>
                    <li>Cloud-Edge Continuum for Internet of Things, Smart Industries and Smart Cities</li>
                    <li>Design and Deployment Models for the Cloud-Edge Continuum</li>
                    <li>Edge Intelligence and Cognitive Computing Continuum</li>
                    <li>Mobile and Energy-efficient use of the Cloud-Edge Continuum</li>
                    <li>Multi-access Edge Computing / Mobile Edge Computing</li>
                    <li>Principles and Theoretical Foundations of Utility Computing, Including Pricing and Service Models</li>
                    <li>Policy Languages and Programming Models, such as Edge-Native and Edge-Enabled Applications</li>
                    <li>Scalability and Resource Management: Brokering, Scheduling, Capacity Planning, Parallelism and Elasticity</li>
                    <li>Serverless Computing</li>
                    <li>Utility-Driven Models and Mechanisms for Cloud Federations</li>
                    <li>Virtualization Technologies and Other Enablers</li>
                </ul>
                <br />
                <h2>RESPONSIBILITIES</h2>
                <p>Workshop chair(s) will be responsible for the following:</p>
                <ul>
                    <li>Setup the submission system of your choice.</li>
                    <li>Invite TPC members.</li>
                    <li>
                    Produce a web site and a “Call for Papers/Participation” for their workshop. The URL should be sent to the UCC Workshops chairs. The call must make it clear that the workshop is open to all members of the Cloud, Edge, Fog, Big Data, Grid, and Cluster Computing community. It should mention that at least one author of each accepted submission must attend the workshop and that all workshop participants must register under the UCC 2023 workshop day registration fee or the conference fee. The CfP should make it clear that the registration of at least one author requires the full (non-student, non-workshop) rate.
                    </li>
                    <li>
                        Ensure that all workshop papers are a maximum of 6 pages in length, following the main conference format. It is the responsibility of the workshop organizers to ensure that this page limit has been adhered to. Additional pages
                        may be purchased (in some circumstances) subject to approval by the proceedings chair.
                    </li>
                    <li>Provide a brief description of the workshop for the conference web page and program.</li>
                    <li>Select the participants and the format of the workshop. </li>
                    <li>Advertise the workshop beyond the conference web page.</li>
                    <li>Assist in producing a camera-ready version of the workshop proceedings.</li>
                    <li>The conference will take place in person and one workshop organizer should attend the conference to take care of the workshop sessions.</li>
                </ul>
                <p>The UCC 2023 Conference Organizing Committee will be responsible for the following:</p>
                <ul>
                    <li>Provide a link to the workshop's web site on the main conference site.</li>
                    <li>Provide logistics support and a meeting place for the workshop.</li>
                    <li>In conjunction with the organizers, determine the workshop date and time.</li>
                    <li>Provide copies of the workshop proceedings to attendees. Workshop proceedings will be published by ACM, following the UCC conference proceedings for the current year.</li>
                </ul>
                <br />
                <h2>Details and Important Notes</h2>
                <ol>
                    <li>
                        If the workshop is too small (i.e., it does not attract enough submissions) the UCC 2023 Organizing Committee may decide to merge that workshop with another. We encourage workshop organizers to attract a large community. In extreme situations we may also cancel workshops if there are not enough submissions. 
                    </li>
                    <li>
                        Workshop organizers must ensure that suitable quality measures have been taken to ensure that the accepted papers are of high quality. All papers must be reviewed by an international Technical Program Committee with a minimum
                        of 3 reviews per paper. The workshop organizers should also try to observe an acceptance rate that is no higher than 50%.
                    </li>
                    <li>Workshops are not automatically endorsed by ACM and should not use the names of these organizations in their titles.</li>
                </ol>
            </Content>
        </PageWrapper>
    );
};

export default CallForWorkshops;
